<template>
  <div :class="(showTickets && 'ticketList', isZkm && 'ticketListZkm')">
    <div>
      <div
        v-if="!$apollo.loading && showHeader && !event.soldOut && showTickets && !event.canceled && !hasEventFinished()"
        style="margin-bottom: 2.5rem"
      >
        <module-title
          color="#333333"
          :title="styles.apply || $t('buyATicket')"
          :font-style="!isZkm && titleStyle"
        />
      </div>
      <div class="title-description mb-32 mt-12">
        {{ styles.titleDescription || 'Ovdje možeš kupiti jednu ili više karata' }}
      </div>
      <div>
        <div
          v-if="
            (event.soldOut || !showTickets || event.canceled || hasEventFinished()) &&
              !$apollo.loading
          "
          class="no-tickets"
        >
          <img :src="getModalImage" alt="no tickets">
          <module-title
            color="#333333"
            :title="getModalTitle"
            :description="getModalDescription"
            :show-events-button="true"
            class="pb-4"
          />
          <div
            v-if="event.canceled && event.cancellationNotification"
            class="cancel-notification"
          >
            <div>{{ $t('organizerMessage') }}:</div>
            <div v-html="event.cancellationNotification" />
          </div>
        </div>
        <div v-else-if="categories.length">
          <div
            v-for="[organizationItemCategoryId, orderItems] in categories"
            :key="categories.id"
            style="margin-bottom: 1rem"
          >
            <div
              v-if="
                !checkIfAllTicketsInCategorySoldOut(organizationItemCategoryId) ||
                  getOrganizationItemCategory(organizationItemCategoryId).displayIfSoldOut
              "
              :style="{
                background: getOrganizationItemCategory(organizationItemCategoryId).color + '14',
                color: getOrganizationItemCategory(organizationItemCategoryId).color,
                border:
                  '1px solid ' +
                  getOrganizationItemCategory(organizationItemCategoryId).color +
                  '80',
              }"
              class="organization-item-category-container"
            >
              <div class="category-container-header">
                <p class="category-name">
                  {{ getOrganizationItemCategory(organizationItemCategoryId).name }}
                </p>
                <p
                  v-if="getOrganizationItemCategory(organizationItemCategoryId).description"
                  class="category-description"
                  style="margin: 0"
                >
                  {{ getOrganizationItemCategory(organizationItemCategoryId).description }}
                </p>
              </div>
              <template v-if="!isZkm">
                <ticket-card
                  v-for="orderItem in orderItems"
                  :ticket="orderItem"
                  :event="event"
                  :promo-code="promoCode"
                  :items="selectedTicket"
                  style="width: 100%"
                  :can-add-more="canAddMoreCheck(orderItem)"
                  active-background-color="white"
                  :color="getOrganizationItemCategory(organizationItemCategoryId).color"
                  is-part-of-category
                  @added="addTicketToCart"
                  @removed="removeTicketToCart"
                />
              </template>
              <template v-else>
                <ticket-card-zkm
                  v-for="orderItem in orderItems"
                  :ticket="orderItem"
                  :event="event"
                  :promo-code="promoCode"
                  :items="selectedTicket"
                  style="width: 100%"
                  :can-add-more="canAddMoreCheck(orderItem)"
                  active-background-color="white"
                  :color="getOrganizationItemCategory(organizationItemCategoryId).color"
                  is-part-of-category
                  @added="addTicketToCart"
                  @removed="removeTicketToCart"
                />
              </template>
            </div>
          </div>
          <div
            v-for="orderItem in withoutCategories"
            :key="orderItem.id"
            style="padding: 0 1.5rem"
            class="no-categories-container"
          >
            <template v-if="!isZkm">
              <ticket-card
                :ticket="orderItem"
                :event="event"
                :promo-code="promoCode"
                :items="selectedTicket"
                :can-add-more="canAddMoreCheck(orderItem)"
                color="#333333"
                style="margin-bottom: 1rem"
                background-color="#3333330d"
                active-background-color="white"
                @added="addTicketToCart"
                @removed="removeTicketToCart"
              />
            </template>
            <template v-else>
              <ticket-card-zkm
                :ticket="orderItem"
                :event="event"
                :promo-code="promoCode"
                :items="selectedTicket"
                :can-add-more="canAddMoreCheck(orderItem)"
                color="#333333"
                style="margin-bottom: 1rem"
                background-color="#3333330d"
                active-background-color="white"
                @added="addTicketToCart"
                @removed="removeTicketToCart"
              />
            </template>
          </div>
        </div>
        <div v-else>
          <div v-for="item in items" :key="item.id" class="mb-32">
            <p v-if="titlesMap[item.id]" class="title-map-style">{{ titlesMap[item.id] }}</p>
            <template v-if="!isZkm">
              <ticket-card
                :ticket="item"
                :event="event"
                :promo-code="promoCode"
                :items="selectedTicket"
                :can-add-more="canAddMoreCheck(item)"
                color="#333333"
                style="margin-bottom: 1rem"
                background-color="#3333330d"
                active-background-color="white"
                @added="addTicketToCart"
                @removed="removeTicketToCart"
              />
            </template>
            <template v-else>
              <ticket-card-zkm
                :ticket="item"
                :event="event"
                :promo-code="promoCode"
                :items="selectedTicket"
                :can-add-more="canAddMoreCheck(item)"
                :color="eventColor"
                :background-color="getThemeStyle(event.coverImagePrimaryColor, 0.05, 'primary')"
                @added="addTicketToCart"
                @removed="removeTicketToCart"
              />
            </template>
          </div>
        </div>
      </div>
      <div v-if="isZkm" id="zkm-svg-container">
        <p class="svg-description">Dostupnost ulaznica</p>
        <svg id="zkm-svg" />
      </div>
      <v-snackbar v-if="styles.required || snackbarOpen" v-model="snackbarOpen">
        <span>{{ styles.snackbarText || 'Potrebno je odabrati barem jednu kartu' }}</span>
      </v-snackbar>
      <div v-if="isZkm" class="attendee-actions attendee-modals-zkm">
        <main-button
          id="backButton"
          class="back-btn"
          flat
          :text="styles.goBack || $t('back')"
          color="#333333"
          @click="goToMainPage"
        />
        <main-button
          id="continuePurchaseButton"
          :disabled="!selectedTicket.length"
          class="purchase-btn"
          depressed
          :text="styles.purchase || $t('continueShopping')"
          color="#333333"
          @click="$emit('next')"
        />
        <router-link
          v-if="seeTickets && lastOrderId"
          target="_blank"
          :to="{
            name: routes.ungrouped.ticketPdf,
            params: { orderId: lastOrderId, purchaseIndex: 'all' },
          }"
        >
          Pogledaj karte
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ModuleTitle from './../../shared/module-title.vue'
import { GET_ONLINE_ORDER_ITEMS } from '@/graphql/orderItem.graphql'
import TicketCard from '../../tickets/ticket-card'
import { isDateBetween, landingURL } from '@/utils'
import moment from 'moment'
import TicketCardZkm from '@/components/tickets/ticket-card-zkm.vue'

const initialSeatColors = Object.freeze({
  AVAILABLE: '#979797',
  SELECTED: '#4DAFBB',
  UNAVAILABLE: '#f5f5f5',
  UNAVAILABLE_BORDER: '#d9d9d9',
})
export default {
  components: {
    TicketCardZkm,
    TicketCard,
    ModuleTitle,
  },
  props: {
    initialPromoCode: {
      type: String,
      default: null,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    event: {
      type: Object,
      default: null,
    },
    selected: {
      type: Array,
      default: () => [],
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
    initialValues: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: '#333333',
    },
    seeTickets: {
      type: Boolean,
      default: false,
    },
    lastOrderId: {
      type: String,
      default: null,
    },
    promoCode: {
      type: Object,
      default: null,
    },
    membership: {
      type: Object,
      default: null,
    },
    numOfRemainingTickets: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      eventColor: this.event.eventTemplateId
        ? '#333'
        : this.getThemeStyle(this.event.coverImagePrimaryColor, null, 'primary'),
      items: [],
      showTickets: false,
      ticketsSoldOut: false,
      selectedItem: {
        type: Array,
        default: () => [],
      },
      disabledItem: [],
      allOrganizationItemCategories: [],
      snackbarOpen: false,
      allAvailableTickets: null,
      startingSeatId: this.event.audienceCapacity - this.numOfRemainingTickets,
      selectedTicket: this.initialValues || [],
      selectPromo: false,
      numberOfAvailableTickets: 0,
      titlesMap: {
        1142: 'MOTOVUN 22.7.',
        1151: 'MOTOVUN 23.7.',
        1155: 'MOTOVUN 24.7.',
        1161: 'PETEHOVAC 26.7.',
        1162: 'PETEHOVAC 27.7.',
        1168: 'PETEHOVAC 28.7.',
        1174: 'PETEHOVAC 29.7.',
        1089: 'AUTOBUS',
      },
      secondaryColor: '#FF4C00',
      zkmColor: '#333333',
      categories: [],
      withoutCategories: [],
      titleStyle: {
        fontFamily: 'Raleway',
        fontSize: '2.25rem',
        fontStyle: 'normal',
        fontWeight: '800',
        lineHeight: '120%',
        letterSpacing: '-0.0675rem',
      },
    }
  },
  computed: {
    totalTicketsSelected() {
      return this.selectedTicket.length
    },
    isZkm() {
      return this.event.organization.id == process.env.VUE_APP_ZKM_ORGANIZATION_ID
    },
    getModalTitle() {
      if (this.event.canceled) {
        return this.$t('eventCanceled')
      }

      if (this.ticketsSoldOut) {
        return this.$t('ticketSoldOut')
      }

      return this.$t('ticketUnavailable')
    },
    getModalDescription() {
      if (this.event.canceled) {
        if (Number(this.event.id) === 3375) {
          return ''
        }

        return this.$t('eventCanceledDescription')
      }

      if (this.ticketsSoldOut) {
        return this.$t('ticketSoldOutDescription')
      }

      return this.$t('ticketUnavailableDescription')
    },
    getModalImage() {

      if (this.event.canceled) {
        return '/assets/sad-ticket.svg'
      }

      if (this.ticketsSoldOut) {
        return '/assets/sad-ticket.svg'
      }

      return '/assets/dont-know-ticket.svg'
    },
  },
  apollo: {
    getOnlineOrderItems: {
      query: GET_ONLINE_ORDER_ITEMS,
      variables() {
        return {
          eventId: this.event.id,
        }
      },
      manual: true,
      result({ loading, data }) {
        if (!loading) {
          this.$emit('startLoading')
          const { getOnlineOrderItems } = data

          if (getOnlineOrderItems) {
            const availableTickets = this.getAvailableTickets(getOnlineOrderItems)
            const unavailableTickets = this.getUnavailableTickets(getOnlineOrderItems)

            this.items = [...availableTickets, ...unavailableTickets]

            if (this.event.organization.type === 'REGULAR') {
              const allTicketsSold =
                !!this.items.length &&
                this.items.every(item => {
                  const currAvailable = item.currentlyAvailable
                  this.numberOfAvailableTickets += currAvailable

                  return currAvailable === 0 && !item.showIfSold
                })

              this.showTickets = !allTicketsSold && this.items.length > 0
              this.ticketsSoldOut = allTicketsSold || this.event.soldOut

              if (this.event.audienceCapacity) {
                this.showTickets = Number(this.numOfRemainingTickets) > 0
              }
            } else {
              this.numberOfAvailableTickets = this.numOfRemainingTickets
              this.showTickets = !(Number(this.numOfRemainingTickets) <= 0)
              this.ticketsSoldOut = this.numOfRemainingTickets <= 0 || this.event.soldOut
              this.isZkm && this.drawSvg()
            }
            const orderItemsByCategory = {}
            for (const ticket of this.items) {
              if (ticket.organizationItemCategory) {
                this.allOrganizationItemCategories.push(ticket.organizationItemCategory)
                if (orderItemsByCategory[ticket.organizationItemCategory.id]) {
                  orderItemsByCategory[ticket.organizationItemCategory.id].push(ticket)
                } else {
                  orderItemsByCategory[ticket.organizationItemCategory.id] = [ticket]
                }
              } else {
                this.withoutCategories.push(ticket)
              }
            }
            this.categories = Object.entries(orderItemsByCategory)
              .sort(([, a], [, b]) => {
                return (
                  a[0].organizationItemCategory.priority - b[0].organizationItemCategory.priority
                )
              })
              .map(c => [c[0], c[1].sort((a, b) => b.createdAt - a.createdAt)])
          }
          this.allOrganizationItemCategories = [...new Set(this.allOrganizationItemCategories)]

          this.$emit('finishLoading')
        }
      },
    },
  },
  watch: {
    selectedTicket: function() {
      this.$emit('selectedTickets', this.selectedTicket)
    },
    membership: function() {
      if (!this.membership) {
        const numOfSeatsToRemove = this.selectedTicket.length - this.initialValues.length
        this.selectedTicket = this.initialValues
        this.items = this.items.filter(i => !i.membership)
        if (this.isZkm) {
          for (let i = 1; i <= numOfSeatsToRemove; i++) {
            this.changeSvgSeatColor(
              (this.startingSeatId + (this.initialValues.length + i)).toString(),
              initialSeatColors.AVAILABLE,
            )
          }
        }
      }
    },
  },
  methods: {
    getOrganizationItemCategory(id) {
      return this.allOrganizationItemCategories.find(c => c.id === id)
    },
    drawSvg() {
      const svgn = 'http://www.w3.org/2000/svg'
      const svg = document.getElementById('zkm-svg')
      let cy = 25
      let cx = 25
      let j = 0
      let height = 150
      const containerWidth = document.getElementById('zkm-svg').clientWidth - cx
      for (let i = 0; i <= this.event.audienceCapacity; i++) {
        j += 1
        25 * j > containerWidth && (j = 1) && (cy += 25) && (height += 45)
        const circle = document.createElementNS(svgn, 'circle')
        circle.setAttributeNS(null, 'id', i.toString())
        circle.setAttributeNS(null, 'cx', (cx * j).toString())
        circle.setAttributeNS(null, 'cy', cy.toString())
        circle.setAttributeNS(null, 'r', '10')
        circle.setAttributeNS(
          null,
          'fill',
          i <= this.event.audienceCapacity - this.numOfRemainingTickets
            ? initialSeatColors.UNAVAILABLE
            : initialSeatColors.AVAILABLE,
        )
        svg.appendChild(circle)
      }
      document.getElementById('zkm-svg-container').style.height = `${height}px`
      !this.showTickets && (document.getElementById('zkm-svg-container').style.display = 'none')
    },
    triggerButtonClick() {
      this.$el.querySelector('#continuePurchaseButton').click()
    },
    canAddMoreCheck(ticket) {
      if (this.membership && ticket.membership) {
        const numberOfMembershipTickets = this.initialValues.filter(t => t.membership).length

        return numberOfMembershipTickets < this.membership.membershipPlan.amount
      }
      const boughtTicketAmount = this.items.reduce((acc, curr) => {
        return (acc += curr.initialQuantity - parseInt(curr.quantity))
      }, 0)
      let currTicketNumber = this.selectedTicket.filter(t => t.id === ticket.id).length

      return this.event.eventTemplateId
        ? this.totalTicketsSelected < 10 &&
        this.numberOfAvailableTickets - this.totalTicketsSelected !== 0 &&
        this.totalTicketsSelected + boughtTicketAmount < this.event.audienceCapacity
        : this.totalTicketsSelected <
        ((this.event.flags && this.event.flags.ticketsPerOrder) || 10) &&
        (ticket.itemMeta && ticket.itemMeta.max ? currTicketNumber < ticket.itemMeta.max : true)
    },
    getUnavailableTickets(allTickets) {
      return allTickets
        .filter(val => {
          if (val.quantity <= 0 || moment(val.to).isBefore(new Date())) {
            if (val.organizationItemCategory) {
              return val.organizationItemCategory.displayIfSoldOut
            }

            return val.showIfSold
          }

          return false
        })
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    },
    getAvailableTickets(allTickets) {
      this.allAvailableTickets = allTickets.filter(val => isDateBetween(val) && val.quantity > 0)

      return allTickets
        .filter(val => isDateBetween(val) && val.quantity > 0 && !val.membership)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    },
    changeSvgSeatColor(id, color) {
      document.getElementById(id).setAttributeNS(null, 'fill', color)
    },
    addTicketToCart(ticket) {
      if (ticket.membership) {
        const numberOfMembershipTickets = this.initialValues.filter(t => t.membership).length
        numberOfMembershipTickets < this.membership.membershipPlan.amount &&
        this.selectedTicket.push(ticket)
      } else {
        this.selectedTicket.push(ticket)
      }
      this.isZkm &&
      this.changeSvgSeatColor(
        (this.startingSeatId + this.selectedTicket.length).toString(),
        initialSeatColors.SELECTED,
      )
    },
    removeTicketToCart(ticket) {
      const index = this.selectedTicket.findIndex(item => item.id === ticket.id)
      this.isZkm &&
      this.changeSvgSeatColor(
        (this.startingSeatId + this.selectedTicket.length).toString(),
        initialSeatColors.AVAILABLE,
      )
      this.selectedTicket.splice(index, 1)
    },
    addPromo() {
      return (this.selectPromo = !this.selectPromo)
    },
    applyPromoCode(promoCodeInput) {
      this.$emit('applyPromo', promoCodeInput)
    },
    triggerMembershipClick(membershipNumber) {
      this.applyMembership(membershipNumber)
    },
    applyMembership(membershipInput) {
      this.items.push(
        this.allAvailableTickets.find(oi =>
          membershipInput.membershipPlan.orderItemTemplates.some(
            oit => oit.id === parseInt(oi.orderItemTemplateId),
          ),
        ),
      )
      this.snackbarOpen = true
      this.styles.snackbarText = 'Vaše članstvo uključuje jednu ulaznicu po povlaštenoj cijeni.'
      this.$emit('applyMembership', membershipInput)
    },
    removePromoCode() {
      if (this.membership) {
        this.selectedTicket = this.selectedTicket.filter(
          st =>
            parseInt(st.orderItemTemplateId) !== this.membership.membershipPlan.orderItemTemplateId,
        )
      }
      this.$emit('removePromoCode')
    },
    goToMainPage() {
      window.location.href = `${landingURL}/events/${this.event.slug}`
    },
    checkIfAllTicketsInCategorySoldOut(organizationItemCategoryId) {
      for (const orderItem of this.categories.find(
        item => item[0] === organizationItemCategoryId,
      )[1]) {
        if (orderItem.currentlyAvailable > 0) {
          return false
        }
      }

      return true
    },
    hasEventFinished() {
      return moment().isAfter(moment(this.event.to))
    },
  },
}
</script>

<style scoped>
.attendee-actions-zkm {
  visibility: hidden;
}

.promo-style {
  margin-top: 2rem;
  margin-bottom: 24px;
  display: flex;
  width: 204px;
}

.center-icon {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  padding-top: 2px;
  text-transform: uppercase;
  margin-left: 6px;
}

.promoCode-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: left;
}

.no-tickets {
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-bottom: 3rem;
}

.no-tickets img {
  margin: 64px 0 20px;
}

.description {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  color: #333333;
  text-align: center;
}

@media screen and (max-width: 415px) {
  .ticketList {
    max-width: 300px;
    margin: 0 auto;
  }

  .ticketListZkm {
    max-width: unset;
  }
}

@media screen and (max-width: 340px) {
  .ticketList {
    max-width: 250px;
    margin: 0 auto;
  }
}

.title-map-style {
  color: rgb(255, 76, 0);
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
}

#addPromoCodeText {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 12px !important;
  line-height: 15px;
}

.attendee-actions {
  display: flex;
  justify-content: flex-end;
}

@media screen and (max-width: 800px) {
  .attendee-actions {
    flex-direction: column-reverse;
  }
}

#zkm-svg {
  width: 100%;
  height: 100%;
}

.svg-description {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Rubik;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
}

.organization-item-category-container {
  display: flex;
  padding: 1.5rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;
  max-width: 50.1875rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;
  @media screen and (max-width: 800px) {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    border-radius: 0;
    border-left: none !important;
    border-right: none !important;
  }
}

.category-name {
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.5rem;
  margin: 0;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
}

.category-description {
  font-family: Source Sans Pro;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  white-space: pre-line;
  line-height: 150%;
}

.category-container-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  align-self: stretch;
}

.no-categories-container {
  max-width: 50.1875rem;
  @media screen and (max-width: 800px) {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
}

.cancel-notification {
  background-color: #FBEBED;
  color: #BD2A3C;
  border-radius: 15px;
  padding: 10px;
}
</style>
